export default {
  'scenarios.create.status_checks.configuration.section.info':
    'Configure the details of your Health Check.',
  'scenarios.create.status_checks.configuration.selected_status_check.text':
    'has been selected from your Health Checks library.',
  'scenarios.create.status_checks.configuration.form.configuration_name.field.label':
    'Health Check Name',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.title':
    'Start from a saved Health Check',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.subtitle':
    'Use a Health Check from your team’s library.',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.link.text':
    'Manage Saved Health Checks',
  'scenarios.create.status_checks.create_status_check.configuration.invalid':
    'Configuration is required to add a Health Check to a scenario',
  'scenarios.create.status_checks.create_status_check.configuration_and_success_evaluation.invalid':
    'Configuration and Success Evaluation are required to add a Health Check to a scenario',
  'scenarios.create.status_checks.create_status_check.success_evaluation.invalid':
    'Success Evaluation is required to add a Health Check to a scenario',
  'scenarios.create.status_checks.success_evaluation.section_title.info.label':
    'Choose success criteria to run a Health Check against.',
  'scenarios.detail.results_form.modal.save_status_check':
    'Save and add Health Check',
  'scenarios.detail.results_form.new_results_form.prompt.add_status_check':
    'Consider adding a Health Check to automate Pass/Fail results.',
  'scenarios.detail.scenario_actions.run_scenario_button.tooltip.text':
    'Add an experiment or Health Check to run this scenario',
  'scenarios.detail.scenario_status_check_details_off_canvas.halted_step.checks_label.text':
    'Scenario was halted by this Health Check while executing:',
  'scenarios.detail.scenario_status_check_details_off_canvas.check_overview.image.alt.text':
    'Health Check Gremlin',
  'scenarios.overview.published_scenario_multi_select.title':
    'Allow any team in your company to copy these Scenarios and run experiments on their own targets.',
  'scenarios.overview.published_scenario_multi_select.subtitle':
    'If they contain any Health Checks the copy will include their configurations, headers and success evaluations.',
  'scenarios.delete_modal.title': 'Delete Scenario?',
  'scenarios.delete_modal.text':
    'Are you sure you want to delete this Scenario?',
  'scenarios.delete_modal.cancel_button': 'Cancel',
  'scenarios.delete_modal.delete_button': 'Delete',
  'scenarios.delete_modal.delete.success': 'Successfully deleted Scenario',
  'scenarios.delete_modal.delete.error':
    'There was a problem while removing the Scenario. Please try again.',
  'scenarios.update_scenario': 'Update Scenario',
  'scenarios.add_to_scenario': 'Add to Scenario',
  'scenarios.delay.seconds': 'Second(s)',
  'scenarios.delay.minutes': 'Minute(s)',
  'scenarios.delay.hours': 'Hour(s)'
}
